export interface SampleRoom {
  id: string;
  name: string;
  description: string;
  imageUrl: string;
  defaultCalibration: {
    topLeft: { x: number; y: number };
    topRight: { x: number; y: number };
    bottomLeft: { x: number; y: number };
    bottomRight: { x: number; y: number };
  };
}

export const sampleRooms: SampleRoom[] = [
  {
    id: "modern-living-room",
    name: "Modern Living Room",
    description: "Neutral walls, oak flooring, large central window",
    imageUrl: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MDAiIGhlaWdodD0iNjAwIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjRmNGY0Ii8+PHBhdGggZD0iTTIwMCAxMDBoNDAwcTAnIDAgMCA0MDBoLTQwMHEnIDAgMCAtNDAwIiBmaWxsPSIjZmZmIi8+PC9zdmc+",
    defaultCalibration: {
      topLeft: { x: 200, y: 100 },
      topRight: { x: 600, y: 100 },
      bottomLeft: { x: 200, y: 500 },
      bottomRight: { x: 600, y: 500 },
    },
  },
  {
    id: "minimalist-bedroom",
    name: "Minimalist Bedroom",
    description: "Soft warm tones, bedside lighting, tall balcony window",
    imageUrl: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MDAiIGhlaWdodD0iNjAwIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjRmNGRlIi8+PHJlY3QgeD0iMTAwIiB5PSI1MCIgd2lkdGg9IjMwMCIgaGVpZ2h0PSI1MDAiIGZpbGw9IiNmZmYiLz48L3N2Zz4=",
    defaultCalibration: {
      topLeft: { x: 100, y: 50 },
      topRight: { x: 400, y: 50 },
      bottomLeft: { x: 100, y: 550 },
      bottomRight: { x: 400, y: 550 },
    },
  },
  {
    id: "contemporary-dining",
    name: "Contemporary Dining / Lounge",
    description: "Deep navy accent wall, bright panoramic window",
    imageUrl: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MDAiIGhlaWdodD0iNjAwIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMWEyNDJiIi8+PHJlY3QgeD0iMTAwIiB5PSIyMDAiIHdpZHRoPSI2MDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjZmZmIi8+PC9zdmc+",
    defaultCalibration: {
      topLeft: { x: 100, y: 200 },
      topRight: { x: 700, y: 200 },
      bottomLeft: { x: 100, y: 400 },
      bottomRight: { x: 700, y: 400 },
    },
  },
];
